import classNames from "classnames/bind";
import AdaptiveCruise24 from "public/icons/trim-options/AdaptiveCruise@24.svg";
import AdaptiveCruise32 from "public/icons/trim-options/AdaptiveCruise@32.svg";
import Aircon24 from "public/icons/trim-options/Aircon@24.svg";
import Aircon32 from "public/icons/trim-options/Aircon@32.svg";
import AlloyWheels24 from "public/icons/trim-options/AlloyWheels@24.svg";
import AlloyWheels32 from "public/icons/trim-options/AlloyWheels@32.svg";
import AwardWinningFriendlyService24 from "public/icons/trim-options/AwardWinningFriendlyService@24.svg";
import AwardWinningFriendlyService32 from "public/icons/trim-options/AwardWinningFriendlyService@32.svg";
import Bluetooth24 from "public/icons/trim-options/Bluetooth@24.svg";
import Bluetooth32 from "public/icons/trim-options/Bluetooth@32.svg";
import CarPlayAndroidAudio24 from "public/icons/trim-options/CarPlayAndroidAudio@24.svg";
import CarPlayAndroidAudio32 from "public/icons/trim-options/CarPlayAndroidAudio@32.svg";
import CleanAirCompliant24 from "public/icons/trim-options/CleanAirCompliant@24.svg";
import CleanAirCompliant32 from "public/icons/trim-options/CleanAirCompliant@32.svg";
import ClimateControl24 from "public/icons/trim-options/ClimateControl@24.svg";
import ClimateControl32 from "public/icons/trim-options/ClimateControl@32.svg";
import ClothSeats24 from "public/icons/trim-options/ClothSeats@24.svg";
import ClothSeats32 from "public/icons/trim-options/ClothSeats@32.svg";
import CruiseControl24 from "public/icons/trim-options/CruiseControl@24.svg";
import CruiseControl32 from "public/icons/trim-options/CruiseControl@32.svg";
import DABRadio24 from "public/icons/trim-options/DABRadio@24.svg";
import DABRadio32 from "public/icons/trim-options/DABRadio@32.svg";
import DigitalCockpit24 from "public/icons/trim-options/DigitalCockpit@24.svg";
import DigitalCockpit32 from "public/icons/trim-options/DigitalCockpit@32.svg";
import ElectricSeatAdjustment24 from "public/icons/trim-options/ElectricSeatAdjustment@24.svg";
import ElectricSeatAdjustment32 from "public/icons/trim-options/ElectricSeatAdjustment@32.svg";
import ElectricSeats24 from "public/icons/trim-options/ElectricSeats@24.svg";
import ElectricSeats32 from "public/icons/trim-options/ElectricSeats@32.svg";
import ElectricSunroof24 from "public/icons/trim-options/ElectricSunroof@24.svg";
import ElectricSunroof32 from "public/icons/trim-options/ElectricSunroof@32.svg";
import ElectricWindows24 from "public/icons/trim-options/ElectricWindows@24.svg";
import ElectricWindows32 from "public/icons/trim-options/ElectricWindows@32.svg";
import FoldingMirrors24 from "public/icons/trim-options/FoldingMirrors@24.svg";
import FoldingMirrors32 from "public/icons/trim-options/FoldingMirrors@32.svg";
import FrontParkingSensor24 from "public/icons/trim-options/FrontParkingSensor@24.svg";
import FrontParkingSensor32 from "public/icons/trim-options/FrontParkingSensor@32.svg";
import FuelTypeDiesel24 from "public/icons/trim-options/FuelTypeDiesel@24.svg";
import FuelTypeDiesel32 from "public/icons/trim-options/FuelTypeDiesel@32.svg";
import FuelTypeEco24 from "public/icons/trim-options/FuelTypeEco@24.svg";
import FuelTypeEco32 from "public/icons/trim-options/FuelTypeEco@32.svg";
import FuelTypePetrol24 from "public/icons/trim-options/FuelTypePetrol@24.svg";
import FuelTypePetrol32 from "public/icons/trim-options/FuelTypePetrol@32.svg";
import HalfLeather24 from "public/icons/trim-options/HalfLeather@24.svg";
import HalfLeather32 from "public/icons/trim-options/HalfLeather@32.svg";
import HeatedSeats24 from "public/icons/trim-options/HeatedSeats@24.svg";
import HeatedSeats32 from "public/icons/trim-options/HeatedSeats@32.svg";
import HomeDelivery24 from "public/icons/trim-options/HomeDelivery@24.svg";
import HomeDelivery32 from "public/icons/trim-options/HomeDelivery@32.svg";
import KeylessEntry24 from "public/icons/trim-options/KeylessEntry@24.svg";
import KeylessEntry32 from "public/icons/trim-options/KeylessEntry@32.svg";
import LaneDepartureWarning24 from "public/icons/trim-options/LaneDepartureWarning@24.svg";
import LaneDepartureWarning32 from "public/icons/trim-options/LaneDepartureWarning@32.svg";
import LaneKeepAssist24 from "public/icons/trim-options/LaneKeepAssist@24.svg";
import LaneKeepAssist32 from "public/icons/trim-options/LaneKeepAssist@32.svg";
import LeatherInterior24 from "public/icons/trim-options/LeatherInterior@24.svg";
import LeatherInterior32 from "public/icons/trim-options/LeatherInterior@32.svg";
import Mileage24 from "public/icons/trim-options/Mileage@24.svg";
import Mileage32 from "public/icons/trim-options/Mileage@32.svg";
import MoneyBackGuarantee24 from "public/icons/trim-options/MoneyBackGuarantee@24.svg";
import MoneyBackGuarantee32 from "public/icons/trim-options/MoneyBackGuarantee@32.svg";
import MotorPointWarranty24 from "public/icons/trim-options/MotorPointWarranty@24.svg";
import MotorPointWarranty32 from "public/icons/trim-options/MotorPointWarranty@32.svg";
import NobodyBeatsUs24 from "public/icons/trim-options/NobodyBeatsUs@24.svg";
import NobodyBeatsUs32 from "public/icons/trim-options/NobodyBeatsUs@32.svg";
import PaintOption24 from "public/icons/trim-options/PaintOption@24.svg";
import PaintOption32 from "public/icons/trim-options/PaintOption@32.svg";
import PanRoof24 from "public/icons/trim-options/PanRoof@24.svg";
import PanRoof32 from "public/icons/trim-options/PanRoof@32.svg";
import PreviousOwner24 from "public/icons/trim-options/PreviousOwner@24.svg";
import PreviousOwner32 from "public/icons/trim-options/PreviousOwner@32.svg";
import PrivacyGlass24 from "public/icons/trim-options/PrivacyGlass@24.svg";
import PrivacyGlass32 from "public/icons/trim-options/PrivacyGlass@32.svg";
import QualityStandard24 from "public/icons/trim-options/QualityStandard@24.svg";
import QualityStandard32 from "public/icons/trim-options/QualityStandard@32.svg";
import RearParkingCamera24 from "public/icons/trim-options/RearParkingCamera@24.svg";
import RearParkingCamera32 from "public/icons/trim-options/RearParkingCamera@32.svg";
import RearParkingSensor24 from "public/icons/trim-options/RearParkingSensor@24.svg";
import RearParkingSensor32 from "public/icons/trim-options/RearParkingSensor@32.svg";
import Registration24 from "public/icons/trim-options/Registration@24.svg";
import Registration32 from "public/icons/trim-options/Registration@32.svg";
import ReserveOnline24 from "public/icons/trim-options/ReserveOnline@24.svg";
import ReserveOnline32 from "public/icons/trim-options/ReserveOnline@32.svg";
import SatNav24 from "public/icons/trim-options/SatNav@24.svg";
import SatNav32 from "public/icons/trim-options/SatNav@32.svg";
import TailoredFinanceOptions24 from "public/icons/trim-options/TailoredFinanceOptions@24.svg";
import TailoredFinanceOptions32 from "public/icons/trim-options/TailoredFinanceOptions@32.svg";
import TrafficLightRecognition24 from "public/icons/trim-options/TrafficLightRecognition@24.svg";
import TrafficLightRecognition32 from "public/icons/trim-options/TrafficLightRecognition@32.svg";
import Transmission24 from "public/icons/trim-options/Transmission@24.svg";
import Transmission32 from "public/icons/trim-options/Transmission@32.svg";
import UltraLowEmissionZoneCompliant24 from "public/icons/trim-options/UltraLowEmissionZoneCompliant@24.svg";
import UltraLowEmissionZoneCompliant32 from "public/icons/trim-options/UltraLowEmissionZoneCompliant@32.svg";
import VoiceControl24 from "public/icons/trim-options/VoiceControl@24.svg";
import VoiceControl32 from "public/icons/trim-options/VoiceControl@32.svg";

import styles from "./TrimOptionIcon.module.scss";

const cx = classNames.bind(styles);

export const ICONS = {
    AdaptiveCruise24,
    AdaptiveCruise32,
    Aircon24,
    Aircon32,
    AlloyWheels24,
    AlloyWheels32,
    AwardWinningFriendlyService24,
    AwardWinningFriendlyService32,
    Bluetooth24,
    Bluetooth32,
    CarPlayAndroidAudio24,
    CarPlayAndroidAudio32,
    CleanAirCompliant24,
    CleanAirCompliant32,
    ClimateControl24,
    ClimateControl32,
    ClothSeats24,
    ClothSeats32,
    CruiseControl24,
    CruiseControl32,
    DABRadio24,
    DABRadio32,
    DigitalCockpit24,
    DigitalCockpit32,
    ElectricSeatAdjustment24,
    ElectricSeatAdjustment32,
    ElectricSeats24,
    ElectricSeats32,
    ElectricSunroof24,
    ElectricSunroof32,
    ElectricWindows24,
    ElectricWindows32,
    FoldingMirrors24,
    FoldingMirrors32,
    FrontParkingSensor24,
    FrontParkingSensor32,
    FuelTypeDiesel24,
    FuelTypeDiesel32,
    FuelTypeEco24,
    FuelTypeEco32,
    FuelTypePetrol24,
    FuelTypePetrol32,
    HalfLeather24,
    HalfLeather32,
    HeatedSeats24,
    HeatedSeats32,
    HomeDelivery24,
    HomeDelivery32,
    KeylessEntry24,
    KeylessEntry32,
    LaneDepartureWarning24,
    LaneDepartureWarning32,
    LaneKeepAssist24,
    LaneKeepAssist32,
    LeatherInterior24,
    LeatherInterior32,
    Mileage24,
    Mileage32,
    MoneyBackGuarantee24,
    MoneyBackGuarantee32,
    MotorPointWarranty24,
    MotorPointWarranty32,
    NobodyBeatsUs24,
    NobodyBeatsUs32,
    PaintOption24,
    PaintOption32,
    PanRoof24,
    PanRoof32,
    PreviousOwner24,
    PreviousOwner32,
    PrivacyGlass24,
    PrivacyGlass32,
    QualityStandard24,
    QualityStandard32,
    RearParkingCamera24,
    RearParkingCamera32,
    RearParkingSensor24,
    RearParkingSensor32,
    Registration24,
    Registration32,
    ReserveOnline24,
    ReserveOnline32,
    SatNav24,
    SatNav32,
    TailoredFinanceOptions24,
    TailoredFinanceOptions32,
    TrafficLightRecognition24,
    TrafficLightRecognition32,
    Transmission24,
    Transmission32,
    UltraLowEmissionZoneCompliant24,
    UltraLowEmissionZoneCompliant32,
    VoiceControl24,
    VoiceControl32,
} as const;

export interface TrimOptionIconProps {
    className?: string;
    color?: string;
    icon: keyof typeof ICONS;
    svgProps?: object;
}

const TrimOptionIcon = (props: TrimOptionIconProps) => {
    const { color, icon, svgProps, className } = props;
    const Svg = ICONS[icon];

    const style = { ["--icon-color"]: color } as React.CSSProperties;

    return (
        <figure className={cx("trimOptionIcon", className)} style={style}>
            <Svg {...svgProps} />
        </figure>
    );
};

export default TrimOptionIcon;
